<template>
  <div class="toggle-input">
    <div class="edit" v-if="!readOnly">
       
        <div v-for="valueOpt in valueOptions" :key="valueOpt"
          class="option"
          :class="internalValue === valueOpt ? 'selected' : 'unselected'"
          @click="()=>changeInternalValue(valueOpt)"
        >
          {{ valueOpt }}
        </div>
        <!-- <div class="separator"></div> -->
      
     
      <!-- <div
        class="option"
        :class="internalValue === valueOptions[1] ? 'selected' : 'unselected'"
        @click="changeInternalValue"
      >
        {{ valueOptions[1] }}
      </div> -->
      <!-- <multi-select-component :label="name" :mode="multipleOrSingle" v-model="internalValue" :options="valueOptions" :configurationOptions="{'allow-empty': false, 'label-inside':false}"/> -->
    </div>
    <span v-else class="value">{{ value.join(', ') }}</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'

export default {
  name: 'ToggleInput',
  mixins: [inputMixin],
  components: {},
  methods: {
    changeInternalValue (target) {
      if(this.valueOptions.length===2){
        if (this.internalValue === this.valueOptions[0]) {
          this.internalValue = this.valueOptions[1]
        } else {
          this.internalValue = this.valueOptions[0]
        }
      } else {
        this.internalValue = target
      }
      this.$emit('child-event');
    }
  }
}
</script>

<style lang="stylus" scoped>
.toggle-input
  align-items: center
  display: flex

.edit
  align-items: center
  border-radius: 4px
  box-shadow: 5px 5px 20px rgba($lynch, 0.25)
  display: flex


.option
  align-items: center
  background-color: #fff
  color: $cloud-burst
  cursor: pointer
  display: flex
  height: 32px
  justify-content: center
  overflow: hidden
  m-font-size(13, 16)
  padding-left: 1.5em
  padding-right: 1.5em
  position: relative

  &:after
    border: 1px solid #fff
    content: ""
    display: block
    height: 100%
    left: 0
    position: absolute
    top: 0
    width: calc(100% + 1px)

  &.unselected
    color $heather
    &:hover
      color $lynch
      &:after
        border-color: $heather

  &:first-child
    border-radius: 4px 0 0 4px

    &:after
      border-radius: 4px 0 0 4px

  &:last-child
    border-radius: 0 4px 4px 0

    &:after
      border-radius: 0 4px 4px 0
      left: -1px

  &.selected
    background-color: transparent
    cursor: default

    &:after
      border-color: $cloud-burst
      left: 0
      width: 100%

  &.unselected
    &:hover
      border-color: $heather
      
  &:not(:last-child)
    border-right solid 1px $iron
  // &:not(:first-child)
  //   border-left solid 1px $heather
    // &:before
    //   content: ''
    //   position absolute
    //   right 0
    //   background-color: $heather
    //   display: block
    //   height: 32px
    //   width: 1px


</style>